import { lineItemDefaultData } from '../store/dataSlice'

/**
 * Add a new line item to the form
 * @param {Function} setFieldValue - Formik setFieldValue function
 * @param {Object} values - Current form values
 * @param {Array} accountCodes - Available account codes
 */
export const handleLineItemAdd = (setFieldValue, values, accountCodes = []) => {
    // Use first available account code if default '200' doesn't exist
    const defaultAccountCode = accountCodes.find(code => code.value === '200') ? '200' : accountCodes[0]?.value || ''

    const newLineItem = {
        ...lineItemDefaultData,
        account_code: defaultAccountCode,
    }

    const newLineItems = [...values.line_items, newLineItem]
    setFieldValue('line_items', newLineItems)
}

/**
 * Remove a line item from the form
 * @param {Function} setFieldValue - Formik setFieldValue function
 * @param {Object} values - Current form values
 * @param {number} index - Index of line item to remove
 */
export const handleLineItemRemove = (setFieldValue, values, index) => {
    if (values.line_items.length > 1) {
        const newLineItems = values.line_items.filter((_, i) => i !== index)
        setFieldValue('line_items', newLineItems)
    }
}

/**
 * Update a specific field in a line item
 * @param {Function} setFieldValue - Formik setFieldValue function
 * @param {Object} values - Current form values
 * @param {number} index - Index of line item to update
 * @param {string} field - Field name to update
 * @param {any} value - New value for the field
 */
export const handleLineItemUpdate = (setFieldValue, values, index, field, value) => {
    const newLineItems = [...values.line_items]
    newLineItems[index] = { ...newLineItems[index], [field]: value }

    // Calculate line total
    if (field === 'quantity' || field === 'unit_amount') {
        const quantity = parseFloat(newLineItems[index].quantity) || 0
        const unitAmount = parseFloat(newLineItems[index].unit_amount) || 0
        newLineItems[index].line_total = quantity * unitAmount
    }

    setFieldValue('line_items', newLineItems)
}
